module.exports = __webpack_public_path__ + "static/ambato-1284b6cc5ff5dea859e18dc3460a0d9b.jpg";